import { colOf, rowOf } from './engine';
import type { GameState, Move } from './types';

export function stateToPikafishFen(state: GameState): string {
  const rows: string[] = [];
  const letters = { K: 'K', A: 'A', E: 'B', R: 'R', C: 'C', H: 'N', P: 'P' } as const;
  for (let row = 0; row < 10; row += 1) {
    let empty = 0;
    let text = '';
    for (let col = 0; col < 9; col += 1) {
      const piece = state.board[row * 9 + col];
      if (!piece) {
        empty += 1;
        continue;
      }
      if (empty) text += String(empty);
      empty = 0;
      const letter = letters[piece.type];
      text += piece.side === 'red' ? letter : letter.toLowerCase();
    }
    if (empty) text += String(empty);
    rows.push(text);
  }
  const side = state.sideToMove === 'red' ? 'w' : 'b';
  const fullmove = Math.floor(state.moves.length / 2) + 1;
  return `${rows.join('/')} ${side} - - ${state.noCapturePly} ${fullmove}`;
}

export function moveToUci(move: Move): string {
  const square = (index: number) => `${String.fromCharCode(97 + colOf(index))}${9 - rowOf(index)}`;
  return `${square(move.from)}${square(move.to)}`;
}

export function moveFromUci(text: string): Move | null {
  if (!/^[a-i][0-9][a-i][0-9]$/.test(text)) return null;
  const index = (offset: number) => (9 - Number(text[offset + 1])) * 9 + text.charCodeAt(offset) - 97;
  return { from: index(0), to: index(2) };
}
